import React from 'react';
import Notification from 'rc-notification';
import notificationStore from '../../store/notificationStore';
import { FaExclamationTriangle, FaCheckCircle, FaSave, FaTrash } from 'react-icons/fa';

/**creates a notification elment whenever one is recieved to the store*/
class Notifications extends React.Component {
    constructor(propos) {
        super();
        this.state = {
            notification: null
        };
    }
    componentDidMount() {
        this.setState({
            // eslint-disable-next-line
            notification: Notification.newInstance({ style: { top: "10%", left: "75%" } }, (n) => this.state.notification = n)
        });
        notificationStore.on("Notifications", this.simpleNotification);
    }
    componentWillUnmount() {
        notificationStore.removeListener("Notifications", this.simpleNotification);
    }
    simpleNotification = () => {
        let icon;
        if (notificationStore.notification.status === "fail") {
            icon = <FaExclamationTriangle style={{ color: "red", fontSize: "x-large", verticalAlign: 'middle' }} />;
        } else if (notificationStore.notification.status === "success") {
            icon = <FaCheckCircle style={{ color: "green", fontSize: "x-large" }} />;
        } else if (notificationStore.notification.status === "saving") {
            icon = <FaSave style={{ fontSize: "x-large" }} />;
        } else if (notificationStore.notification.status === "removing") {
            icon = <FaTrash style={{ fontSize: "x-large" }} />;
        }
        this.state.notification.notice({
            content: <div>
                {icon} &nbsp;
                {notificationStore.notification.message}
            </div>,
            onClose() {
            },
            // style: { left: '10%'},
            duration: 2,
            closable: true,
            maxCounter: 2,
        });
    }
    render() {
        return (<div></div>)
    }
}
export default Notifications;


// WEBPACK FOOTER //
// ./src/components/notifications/Notifications.js